import React from 'react'

import {
    Box,
    Button,
    CircularProgress,
    IconButton,
    Modal,
    Paper,
    Slide,
    Typography,
    useTheme,
} from '@material-ui/core'
import { Close as CloseIcon, Refresh as RefreshIcon } from '@material-ui/icons'

interface VideoPlaybackModalProps {
    open: boolean
    url: string | null
    loading: boolean
    error: string | null
    title?: string
    onClose: () => void
    onRetry?: () => void
}

export const VideoPlaybackModal = ({
    open,
    url,
    loading,
    error,
    title,
    onClose,
    onRetry,
}: VideoPlaybackModalProps) => {
    const theme = useTheme()

    return (
        <Modal
            open={open}
            onClose={onClose}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px',
            }}
        >
            <Slide direction="up" in={open}>
                <Paper
                    elevation={24}
                    style={{
                        width: '90vw',
                        maxWidth: '960px',
                        maxHeight: '90vh',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    {/* Header */}
                    <Box
                        p={2}
                        style={{
                            borderBottom: `1px solid ${theme.palette.divider}`,
                        }}
                    >
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Typography
                                variant="h6"
                                style={{ fontWeight: 600 }}
                            >
                                {title ?? 'Completion Video'}
                            </Typography>
                            <IconButton onClick={onClose} size="small">
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Box>

                    {/* Body */}
                    <Box
                        style={{
                            flex: 1,
                            overflow: 'hidden',
                            backgroundColor: '#000',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            minHeight: 320,
                        }}
                    >
                        {loading && (
                            <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                style={{ color: theme.palette.common.white }}
                            >
                                <CircularProgress color="inherit" />
                                <Typography
                                    variant="body2"
                                    style={{ marginTop: theme.spacing(2) }}
                                >
                                    Loading video…
                                </Typography>
                            </Box>
                        )}

                        {!loading && error && (
                            <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                p={4}
                                style={{
                                    color: theme.palette.common.white,
                                    textAlign: 'center',
                                }}
                            >
                                <Typography variant="body1" gutterBottom>
                                    {error}
                                </Typography>
                                {onRetry && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        startIcon={<RefreshIcon />}
                                        onClick={onRetry}
                                        style={{
                                            marginTop: theme.spacing(1),
                                        }}
                                    >
                                        Try Again
                                    </Button>
                                )}
                            </Box>
                        )}

                        {!loading && !error && url && (
                            <video
                                key={url}
                                src={url}
                                controls
                                autoPlay
                                playsInline
                                preload="metadata"
                                style={{
                                    width: '100%',
                                    maxHeight: '70vh',
                                    backgroundColor: '#000',
                                    outline: 'none',
                                }}
                            />
                        )}
                    </Box>
                </Paper>
            </Slide>
        </Modal>
    )
}

export default VideoPlaybackModal
